import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { LoginFormComponent } from '@libs/authentication';
import { TranslatePipe } from '@ngx-translate/core';
import { BaaSignupFlowService } from '../baa-sign-up-flow.service';

@Component({
  selector: 'lib-baa-signup-login',
  imports: [LoginFormComponent, TranslatePipe],
  templateUrl: './baa-sign-up-login.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BaaSignupLoginComponent {
  protected readonly service = inject(BaaSignupFlowService);

  protected onLogin(credentials: { email: string; password: string }): void {
    this.service.loginForInvitation(credentials);
  }
}
